import { render, staticRenderFns } from "./OntPotsPortStatus.vue?vue&type=template&id=0d5eb27c&"
import script from "./OntPotsPortStatus.vue?vue&type=script&lang=js&"
export * from "./OntPotsPortStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports